import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LocalNavigation, Menu } from '@acast/decibel';
import { PodcastSolidGlyph } from '@acast/decibel-glyphs';
import { selectShowsItems, DEFAULT_COVER_IMAGE } from '../../../ducks/shows';
import navigateTo from '../../../shared/helpers/navigate-to';
import { reactRouterLocationPropType, showPropType } from '../../../customPropTypes';
import { getImage } from '../../../services/image-api';

const isSelectedShow = (location, show) => {
  return location.pathname.includes(show.id);
};

const getThumbnail = show => {
  if (!show.image || !show.image.original) {
    return DEFAULT_COVER_IMAGE;
  }

  return getImage(show.image.original, { w: 20 });
};

function SelectShowDropdown({ location, shows }) {
  return (
    <LocalNavigation.DropdownItem title="Select show" glyph={PodcastSolidGlyph}>
      <Menu>
        {shows.map(show => (
          <Menu.Item
            key={show.id}
            id={show.id}
            thumbnail={getThumbnail(show)}
            onClick={() => navigateTo(`/shows/${show.id}`)}
            selected={isSelectedShow(location, show)}
          >
            {show.name}
          </Menu.Item>
        ))}
      </Menu>
    </LocalNavigation.DropdownItem>
  );
}

SelectShowDropdown.propTypes = {
  location: reactRouterLocationPropType.isRequired,
  shows: T.arrayOf(showPropType).isRequired,
};

export default withRouter(
  connect(state => ({
    shows: selectShowsItems(state),
  }))(SelectShowDropdown)
);
